import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class FormsListService {

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }

    performPagination(pageNumber) {

        let header: any = this._capEngineService.getHeaders('viewTaskTemplateList');
        header.params = {
            category: 'all'
        };
        return this._http.get(environment.serverUrl + '/taskTemplate/pagination/' + pageNumber, header);
    }


    getRawData() {
        return this._http.get(environment.serverUrl + '/rawData', { responseType: 'blob' });
    }

    getTeamDetails() {
        return this._http.get(environment.serverUrl + '/assets/team/');
    }
    duplicateTemplate(templateObj) {
               return this._http.post(environment.formBuilder.serverUrl + '/api/v1/form/duplicate', templateObj);
    }
    publishedFormsCount(){
        return this._http.get(environment.serverUrl + '/taskTemplate/publishCount')
    }
    getTemplateDirecotries(){
        return this._http.get(environment.serverUrl + '/taskTemplate/directories' )
    }
    createDirectory(dirName){
        return this._http.post(environment.serverUrl + '/taskTemplate/directories' , dirName)
    }
    updateLayoutSetting(obj) {
        return this._http.put(environment.serverUrl + '/user/preferences', obj);
    }
    addExistingTemplates(obj){
        return this._http.put(environment.serverUrl + '/taskTemplate/directories', obj);
    }

    deleteDirectory(directoryId: string, templateIds: any) {
        let params: any = {}
        if(templateIds && templateIds.length) {
            params.templateIds = templateIds
        }
        return this._http.delete(`${environment.serverUrl}/taskTemplate/directories/${directoryId}`, { params: params });
    }
}



// WEBPACK FOOTER //
// ./src/app/forms-list/forms-list.service.ts